/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promoflyerheadline2Inputs */

const en_promoflyerheadline2 = /** @type {(inputs: Promoflyerheadline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you in?`)
};

const de_promoflyerheadline2 = /** @type {(inputs: Promoflyerheadline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bist du dabei?`)
};

/**
* | output |
* | --- |
* | "Are you in?" |
*
* @param {Promoflyerheadline2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const promoflyerheadline2 = /** @type {((inputs?: Promoflyerheadline2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promoflyerheadline2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_promoflyerheadline2(inputs)
	return de_promoflyerheadline2(inputs)
});
export { promoflyerheadline2 as "promoFlyerHeadline" }